import { Link } from "react-router-dom";
import { Leaf, ArrowLeft } from "lucide-react";
import Footer from "@/components/Footer";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-[#F8F6F1] flex flex-col" data-testid="privacy-page">
      {/* Nav */}
      <nav className="sticky top-0 z-50 bg-[#F8F6F1]/80 backdrop-blur-xl border-b border-[#D4C9B8]/30">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#9FB89F] to-[#7A9B7E] flex items-center justify-center">
              <Leaf className="w-4 h-4 text-white" />
            </div>
            <span className="font-serif text-xl font-medium text-[#2D3A2D]">My Story</span>
          </Link>
          <Link to="/" className="flex items-center gap-1.5 font-sans text-sm text-[#7A8A7A] hover:text-[#2D3A2D] transition-colors" data-testid="privacy-back-home">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main className="flex-1 max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <h1 className="font-serif text-4xl sm:text-5xl font-medium text-[#2D3A2D] mb-3 tracking-tight" data-testid="privacy-title">
          Privacy Policy
        </h1>
        <p className="font-sans text-sm text-[#7A8A7A] mb-10">Last updated: {new Date().toLocaleDateString("en-IN", { month: "long", year: "numeric" })}</p>

        <div className="prose-custom space-y-8">
          <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
            At my-story.in, your privacy is our highest priority.
          </p>

          <section>
            <h2 className="font-serif text-xl font-medium text-[#2D3A2D] mb-3">1. Data Ownership</h2>
            <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
              You own your story. Your data is fully encrypted, never sold to third parties, and completely private.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-medium text-[#2D3A2D] mb-3">2. Information We Collect</h2>
            <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
              We collect your email address for account creation, your uploaded text/photos for story generation, and your shipping address when ordering a physical book.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-medium text-[#2D3A2D] mb-3">3. How We Use Your Data</h2>
            <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
              Your conversational data is used strictly by our AI engine to generate your book. Your shipping address is shared exclusively with our trusted printing partner for the sole purpose of delivering your physical order.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-medium text-[#2D3A2D] mb-3">4. Data Deletion</h2>
            <p className="font-sans text-base leading-relaxed text-[#4A5D4A]">
              You may request the deletion of your account and all associated stories/photos at any time by contacting our support team. Upon request, all personal data will be permanently wiped from our servers.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;
